export default "__VITE_ASSET__EsAijqRQ__"